import { IPriceable } from './iPriceable';

export interface Gefahr extends IPriceable {
  isSelected: boolean;
  label: string;
  isSelectable: boolean;
  id: string;
  bruttopreis?: number;
  nettopreisProJahr?: number;
  name: string;
  fachschluessel: string;
  reihenfolge: number;
  writeToEinreichenXML: boolean;
  deltafaktor?: number;
  plzFaktor?: number;
  anzahlVorschaeden?: number;
  bausteinAnpassungsfaktor?: number;
}

export const waehlbareGefahren: Array<string> = ['leitungswasser', 'feuer'];
